import { render, staticRenderFns } from "./msHome.vue?vue&type=template&id=6af3ef2e&scoped=true"
import script from "./msHome.vue?vue&type=script&lang=js"
export * from "./msHome.vue?vue&type=script&lang=js"
import style0 from "./msHome.vue?vue&type=style&index=0&id=6af3ef2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6af3ef2e",
  null
  
)

export default component.exports